import { useQuery } from "@tanstack/react-query";
import { QuestionnaireApi } from "../questionnaire.api";
import { questionnaireKeys } from "./questionnaire.keys";

export const useQuestionnaireDefinitionQuery = (slug?: string) => {
  return useQuery({
    queryKey: questionnaireKeys.definition(slug ?? ""),
    queryFn: () => QuestionnaireApi.getDefinition(slug!),
    enabled: Boolean(slug),
    staleTime: Infinity,
  });
};
